import { render, staticRenderFns } from "./IconDots.vue?vue&type=template&id=ad77f5b8&"
import script from "./IconDots.vue?vue&type=script&lang=ts&"
export * from "./IconDots.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports